// import logo from './logo.svg';
import React, { useState, useEffect } from 'react';
import { WifiLoader } from "react-awesome-loaders";
import Header from './components/header';
import Hero from './components/hero';
import About from './components/about';
import Experience from './components/experience';
import Work from './components/work';
import Skills from './components/skills';
import Education from './components/education';
import Contact from './components/contact';
import Footer from './components/footer';

export default function App() {
  const [isActive, setLoaderLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      setLoaderLoaded(false);
      await setTimeout(() => { return setLoaderLoaded(true) }, 2000);
    })();
  }, []);

  return (
    <div className="App">
      <link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" />
      {isActive ? <><Header  />
        <Hero/><About/><Experience /><Work /><Skills /><Education /><Contact /> <Footer /></> :
        <div className='loader-wifi'>
          <WifiLoader
            background={"transparent"}
            desktopSize={"150px"}
            mobileSize={"150px"}
            text={"Nikhil Portfolio"}
            backColor="transparent"
            frontColor="#39FF13"
          />
        </div>}
    </div>
  );
}
